import GraficaDiaFinalReporte from '@/components/GraficaDiaFinalReporte.vue';
import * as XLSX from 'xlsx';
import ExcelJS from 'exceljs';
import Vue from 'vue';
import html2canvas from 'html2canvas';
import { mapGetters } from 'vuex';

const Exports = {
    components: { GraficaDiaFinalReporte },
    data() {
        return {
            parametrosPortada: {},
            graficasListas: false,
            graficasMontadas: new Set(),
            dialogVer: false,
            tabActivo: null,
            cargando: false,
            programaciones: [],
            headers: [
                { text: 'Nombre de la programacion', value: 'nombre_programacion' },
                { text: 'Servicio', value: 'id_servicio' },
                { text: 'Escenario', value: 'tipo_escenario' },
                { text: 'Fecha', value: 'fecha_formateada' },
                { text: 'Acciones', value: 'acciones', sortable: false }
            ],
            dialogEliminar: false,
            programacionSeleccionada: null,
            servicios: [],
            datosGrafica: [],
            datosTabla: [],
            headersTabla: [
                { text: 'Fecha', value: 'fecha' },
                { text: 'Valor', value: 'valor' },
            ],
            TablasGraficas: [],
            infoServicio: {
                id: null,
                metricas: {
                    shrinkage: 0,
                    utilizacion: 0,
                    ausentismo: 0
                },
                ventanas: [],
                auxiliares: []
            },
            tabsPersonalizados: [
                { label: 'Datos Generales', tipo: 'DatosGenerales' },
                { label: 'Plan Horario semanal', tipo: 'TablaResumenSemanal' },
                { label: 'Requeridos', tipo: 'TablaRequeridos' },
                { label: 'Requeridos + Reductores', tipo: 'TablaRequeridos+Reductores' },
                { label: 'Programados', tipo: 'TablaProgramados' },
                { label: 'Programados vs Requeridos', tipo: 'TablaProgramados_Requeridos' },
                { label: 'Graficas por Dia', tipo: 'Graficas' },
                { label: 'Resumen de Eficiencia', tipo: 'ResumenEficiencia' },
                { label: 'Resumen FTE', tipo: 'ResumenFTE' }
            ],
            ordenDias: ['Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado', 'Domingo'],
            nombreOriginal: '',
            graficasOrdenadas: [],
            tipo_escenario: [
                { text: 'Transacciones Entrantes', value: 'transacciones' },
                { text: 'Transacciones Salientes', value: 'horas' },
                { text: 'Agentes', value: 'agentes' }
            ],
        };
    },
    mounted() {
        this.cargarServicios();
        this.ListaProgramaciones();
    },
    computed: {
        ...mapGetters([
            'getCenters',
            //'getCampañas',
            'getSubcampañas',
            'getSegmentos',
            'getUsuarios',
            'getClientes',
            'getPaises',
        ]),

        portadaProcesada() {
            if (!this.infoServicio) return {};
            //console.log('infoServicio', this.infoServicio);

            const buscar1 = (lista, valorRecibido) => {
                if (!valorRecibido) return 'N/A';

                const objeto = lista.find(item => item.Id == valorRecibido || item.id == valorRecibido);
                if (objeto) {
                    return objeto.vc_nombre || objeto.vc_Descripcion || objeto.nombre_completo || 'N/A';
                }

                return valorRecibido;
            };

            const buscar = (lista, valorRecibido) => {
                if (valorRecibido === null || valorRecibido === undefined || valorRecibido === '') {
                    return 'N/A';
                }

                const tieneLetras = /[a-zA-Z]/.test(valorRecibido);

                if (tieneLetras) {
                    return valorRecibido;
                }

                
                const objeto = (lista || []).find(item => {
                    const itemId = item.Id ?? item.id;
                    return String(itemId).trim() === String(valorRecibido).trim();
                });

   
                if (objeto) {
                    return objeto.vc_nombre || objeto.vc_Descripcion || objeto.vc_descripcion || objeto.nombre_completo || 'N/A';
                }

                
                return `ID: ${valorRecibido} (No encontrado)`;
            };

            //console.log('paises', this.getPaises);

            return {
                ...this.infoServicio,
                clienteNombre: buscar(this.getClientes, this.infoServicio.cliente),
                sedeNombre: buscar(this.getCenters, this.infoServicio.sede),
                //campanaNombre: buscar(this.getCampañas, this.infoServicio.campana),
                subcampanaNombre: buscar(this.getSubcampañas, this.infoServicio.subcampana),
                segmentoNombre: buscar(this.getSegmentos, this.infoServicio.segmento),
                solicitaNombre: buscar(this.getUsuarios, this.infoServicio.usuario_solicita),
                encargadoNombre: buscar(this.getUsuarios, this.infoServicio.usuario_encargado),
                paisNombre: buscar(this.getPaises, this.infoServicio.pais),
                // Formato de vigencia combinado
                vigenciaRango: (this.infoServicio.vigencia_inicio && this.infoServicio.vigencia_fin)
                    ? `${this.infoServicio.vigencia_inicio} al ${this.infoServicio.vigencia_fin}`
                    : 'N/A'
            };
        },

        maxEjeYReporte() {
            if (!this.graficasOrdenadas.length) return null;

            let maxGlobal = 0;
            this.graficasOrdenadas.forEach(grafica => {
                const d = grafica.datos;
                // Unimos todos los arrays de datos del día
                const todosLosValores = [
                    ...(d.asignados || []),
                    ...(d.programados || []),
                    ...(d.requeridos || [])
                ];
                if (todosLosValores.length) {
                    const maxDia = Math.max(...todosLosValores);
                    if (maxDia > maxGlobal) maxGlobal = maxDia;
                }
            });

            // Retornamos con el margen del 15% o 20% que usas
            return Math.ceil(maxGlobal * 1.20);
        }

    },
    methods: {
        editarProgramacion(item) {
            // Guardamos los datos en el navegador
            localStorage.setItem('servicioEdicion', item.id_servicio);
            localStorage.setItem('nombreProgramaEdicion', item.nombre_programacion);
            localStorage.setItem('intentandoEditar', 'true');

            // Navegamos a la página de cálculo (limpia)
            this.$router.push('/main/onedayplan');
        },
        getColorEficiencia(valorStr) {
            if (valorStr === "-" || valorStr === null || valorStr === undefined) return '';

            const valor = parseFloat(valorStr);
            // Convertimos el objetivo de eficiencia (ej. 95 a 0.95)
            const entregable = this.TablasGraficas.find(e => e.nombre_datos === 'ParametrosCalculo');
            const objetivoEficiencia = entregable.items.objetivoRQ;
            const h7 = parseFloat(objetivoEficiencia) / 100;

            if (!h7 || h7 === 0) return '';

            // Convertimos el valor de la celda a decimal para comparar (ej. 92 a 0.92)
            const factorV = valor / 100;

            // --- Aplicación de Reglas (De mayor a menor para no pisar condiciones) ---

            // 1. VERDE: >= (1 * h7)
            if (factorV >= (1 * h7)) {
                return 'excel-verde';
            }
            // 2. AMARILLO: >= (0.95 * h7)
            else if (factorV >= (0.95 * h7)) {
                return 'excel-amarillo';
            }
            // 3. ROJO: >= (0.9 * h7)
            else if (factorV >= (0.9 * h7)) {
                return 'excel-rojo';
            }
            // 4. GRIS: < (0.9 * h7)
            else {
                return 'excel-gris';
            }                   // Crítico/Bajo                    // Crítico/Bajo
        },
        getHeatMapColor(dia, intervalo, listaEntregables) {
            const tablaAsignados = listaEntregables.find(e => e.nombre_datos === 'TablaProgramados');
            const tablaProgramados = listaEntregables.find(e => e.nombre_datos === 'TablaRequeridos+Reductores');

            if (!tablaAsignados || !tablaProgramados) return 'transparent';

            // 2. Buscamos la fila específica por el intervalo (ID común)
            const filaAsig = tablaAsignados.items.find(i => i.intervalo === intervalo);
            const filaProg = tablaProgramados.items.find(i => i.intervalo === intervalo);

            if (!filaAsig || !filaProg) return 'transparent';

            const entregable = this.TablasGraficas.find(e => e.nombre_datos === 'ParametrosCalculo');
            const objetivoRQ = entregable.items.objetivoRQ;
            const asignados = parseFloat(filaAsig[dia]) || 0;
            const programados = parseFloat(filaProg[dia]) || 0;
            const n3 = parseFloat(objetivoRQ) / 100;

            if (programados === 0) return 'excel-gris';

            // 3. TU FÓRMULA EXACTA: Porcentaje de cumplimiento
            const factorCumplimiento = asignados / programados;

            // 4. TUS UMBRALES EXACTOS
            if (factorCumplimiento >= 1.10 * n3) return 'excel-rojo';
            if (factorCumplimiento >= 1.00 * n3) return 'excel-verde';
            if (factorCumplimiento >= 0.95 * n3) return 'excel-amarillo';

            return 'excel-gris';
        },
        onDialogChange(val) {
            if (!val) {
                this.cerrarModal(); // se ejecuta al cerrar el modal
            }
        },
        async guardarNombre(item) {
            const nuevoNombre = item.nombre_programacion;
            if (item.nombre_programacion === this.nombreOriginal) {
                // No hay cambios, no hacemos nada
                return;
            }

            try {
                const res = await this.$axios.put('/actualizar-nombre', {
                    nombre_actual: this.nombreOriginal,
                    nuevo_nombre: nuevoNombre,
                });
                if (res.data.status === 'ok') {
                    this.$toast.success('Nombre cambiando con exito');
                    this.ListaProgramaciones();
                    this.nombreOriginal = ''
                } else {
                    this.$toast.error(res.data.message || 'Error al cambiar el nombre');
                }
            } catch (error) {
                console.error('Error al actualizar el nombre:', error);
            }

        },
        cancelarEdicion(item) {
            // Si quieres revertir el cambio, puedes recargar el nombre original
            console.log('Edición cancelada');
        },
        async cargarServicios() {
            try {
                const usuarioId = this.$store.state.id;
                const res = await this.$axios.get(`list-services?usuario=${usuarioId}`);
                this.servicios = res.data;
            } catch (err) {
                console.error('Error al cargar servicios:', err);
                this.$toast.error('No se pudieron cargar los servicios');
            }
        },
        async ListaProgramaciones() {
            this.cargando = true;
            try {
                const usuarioId = this.$store.state.id;
                const res = await this.$axios.get(`listar-programaciones?usuario=${usuarioId}`);
                if (res.data.status === 'ok') {
                    this.programaciones = res.data.data;
                } else {
                    this.$toast.error('Error al cargar programaciones');
                }
            } catch (error) {
                console.error(error);
                this.$toast.error('Error de conexión');
            } finally {
                this.cargando = false;
            }
        },
        abrirDialogEliminar(item) {
            this.programacionSeleccionada = item;
            this.dialogEliminar = true;
        },
        async eliminarProgramacion() {
            const nombre = this.programacionSeleccionada.nombre_programacion;

            try {
                const res = await this.$axios.delete('eliminar-programacion', {
                    data: { nombre_programacion: nombre }
                });

                if (res.data.status === 'ok') {
                    this.$toast.success('Programación eliminada');
                    this.ListaProgramaciones();
                } else {
                    this.$toast.error(res.data.message || 'Error al eliminar');
                }
            } catch (error) {
                console.error(error);
                this.$toast.error('Error de conexión');
            } finally {
                this.dialogEliminar = false;
                this.programacionSeleccionada = null;
            }
        },
        obtenerNombreServicio(id) {
            const servicio = this.servicios.find(s => s.id === id);
            return servicio ? servicio.nombre : `ID ${id}`;
        },
        registrarGraficaMontada(dia) {
            this.graficasMontadas.add(dia);
            if (this.graficasMontadas.size === this.graficasOrdenadas.length) {
                this.graficasListas = true;
            }
            //console.log(this.graficasMontadas.size);
        },
        obtenerTextoTipoEscenario(value) {
            const tipo = this.tipo_escenario.find(t => t.value === value);
            return tipo ? tipo.text : value;
        },
        cerrarModal() {
            this.dialogVer = false;
            this.graficasListas = false;
            this.graficasMontadas.clear();
            this.graficasOrdenadas = [];
            this.tabActivo = null;
            this.programacionSeleccionada = null;
        },
        abrirModalVer(item) {
            this.programacionSeleccionada = item;
            this.dialogVer = true;
            this.tabActivo = null;
            // Reiniciar estado de gráficas
            this.graficasListas = false;
            this.graficasMontadas.clear();

            // Aquí puedes cargar los datos de la gráfica y tabla
            this.cargarDatos(item.nombre_programacion);
        },
        async cargarDatos(nombre) {
            try {
                const nombreCodificado = encodeURIComponent(nombre);
                //console.log(nombreCodificado);
                const res = await this.$axios.get(`/datos-programacion?nombre=${nombreCodificado}`);
                this.TablasGraficas = res.data.datos;
                //console.log(this.TablasGraficas);
                this.infoServicio = res.data.servicio_info;

                if (res.data.parametros) {
                    // Caso registros nuevos: ya viene el objeto procesado
                    this.parametrosPortada = res.data.parametros;
                } else {
                    // Caso registros VIEJOS: No existen parámetros en la BD
                    this.parametrosPortada = {
                        tipo_escenario: 'No registrado',
                        nombre_base: 'N/A',
                        tmg_desplegado: 'N/A',
                        tmg_promedio: '0.00',
                        nivel_servicio: 'N/A',
                        umbral: 'N/A',
                        objetivoRQ: 'N/A',
                        objetivoEficiencia: 'N/A'
                    };
                }
                //console.log("Parámetros cargados:", this.parametrosPortada);

                this.graficasOrdenadas = this.graficasOrdenadasOK();

            } catch (error) {
                console.error('Error al cargar datos:', error);
            }
        },
        graficasOrdenadasOK() {
            const entregable = this.TablasGraficas.find(e => e.nombre_datos === 'Graficas');
            if (!entregable || !entregable.items) return [];

            return this.ordenDias
                .map(dia => ({ dia, datos: entregable.items[dia] }))
                .filter(item => item.datos); // filtra los días que sí tienen datos
        },

        async descargarTodasLasGraficas() {
            await this.$nextTick();

            let container = this.$refs.graficasContenedor;

            if (Array.isArray(container)) {
                container = container[0];
            }

            if (!container || !container.parentElement) {
                console.error('Error: El contenedor de gráficas no es un elemento DOM válido o no está montado.');
                return;
            }

            try {
                const canvas = await html2canvas(container, {
                    scale: 2,
                    useCORS: true,
                    windowHeight: container.scrollHeight,
                });

                const imagenURL = canvas.toDataURL('image/png');
                const link = document.createElement('a');
                link.href = imagenURL;
                link.download = `Graficas_Agentes_${new Date().toISOString().slice(0, 10)}.png`;

                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

            } catch (error) {
                console.error('Fallo al descargar las gráficas:', error);
                console.error('Error original:', error);
            }
        },
        async exportarDetalleConExcelJS() {
            const COLORES_EXCEL = {
                ROJO: {
                    bg: 'FFF8696B', // #F8696B
                    text: 'FFFFFFFF'
                },
                VERDE: {
                    bg: 'FF63BE7B', // #63BE7B
                    text: 'FFFFFFFF'
                },
                AMARILLO: {
                    bg: 'FFFFFF84', // #FFFF84
                    text: 'FF000000' // Letra negra como en tu CSS
                },
                GRIS: {
                    bg: 'FF646464', // #646464
                    text: 'FFFFFFFF'
                }
            };
            const workbook = new ExcelJS.Workbook();

            const sheet = workbook.addWorksheet('Portada');
            sheet.views = [
                { showGridLines: false }
            ];

            // Configuración de columnas
            sheet.columns = [
                { width: 35 }, { width: 20 }, { width: 20 }, { width: 20 }, { width: 20 }
            ];

            // --- 1. ENCABEZADO ---
            sheet.mergeCells('A1:E2');
            const headerCell = sheet.getCell('A1');
            headerCell.value = this.portadaProcesada.nombre;
            headerCell.font = { size: 16, bold: true, color: { argb: 'FFFFFFFF' } };
            headerCell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF008080' } };
            headerCell.alignment = { horizontal: 'center', vertical: 'middle' };

            sheet.mergeCells('A3:E3');
            const subHeader = sheet.getCell('A3');
            subHeader.value = `REGISTRO DE SERVICIO #${this.infoServicio.id} • ELABORADO: ${this.infoServicio.fecha_elaboracion}`;
            subHeader.font = { size: 10, color: { argb: 'FFBBDEFB' } };
            subHeader.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF008080' } };
            subHeader.alignment = { horizontal: 'center' };

            sheet.addRow([]); // Espacio

            // --- 2. ESTRUCTURA DE NEGOCIO ---
            sheet.addRow(['ESTRUCTURA DE NEGOCIO']).font = { bold: true, color: { argb: 'FF757575' } };
            const negocioData = [
                ['PAIS / SEDE',this.portadaProcesada.paisNombre + ' / ' + this.portadaProcesada.sedeNombre],
                ['SEGMENTO', this.portadaProcesada.segmentoNombre],
                ['SUBCAMPAÑA', this.portadaProcesada.subcampanaNombre],
                ['CLIENTE', this.portadaProcesada.clienteNombre],                
                ['SOLICITADO POR', this.portadaProcesada.encargadoNombre]
            ];
            negocioData.forEach(row => {
                const r = sheet.addRow(row);
                r.getCell(1).font = { size: 9, color: { argb: 'FF9E9E9E' } };
                r.getCell(2).font = { bold: true };
            });

            sheet.addRow([]); // Espacio

            // --- 3. MÉTRICAS BASE (%) ---
            sheet.addRow(['MÉTRICAS BASE (%)']).font = { bold: true, color: { argb: 'FF757575' } };
            const metricasRow = sheet.addRow(['Reductores (Shrinkage)', 'Utilización (UTZ)', 'Ausentismo (ABS)']);
            metricasRow.font = { bold: true, size: 9 };
            sheet.addRow([
                `${this.infoServicio.metricas.shrinkage}%`,
                `${this.infoServicio.metricas.utilizacion}%`,
                `${this.infoServicio.metricas.ausentismo}%`
            ]).font = { bold: true, color: { argb: 'FF1976D2' } };

            sheet.addRow([]); // Espacio

            // --- 4. PARÁMETROS DE CÁLCULO ---
            sheet.addRow(['PARÁMETROS DE CÁLCULO']).font = { bold: true, color: { argb: 'FF757575' } };
            sheet.addRow(['ESCENARIO / MODELO', this.parametrosPortada.tipo_escenario.toUpperCase()]);
            sheet.addRow(['TMG (AHT) CONFIGURADO', this.parametrosPortada.tmg_desplegado]);
            if (this.parametrosPortada.tmg_promedio !== '0.00') {
                sheet.addRow(['PROMEDIO REAL', `${this.parametrosPortada.tmg_promedio}s`]).getCell(2).font = { color: { argb: 'FF1976D2' }, bold: true };
            }
            sheet.addRow(['NIVEL DE SERVICIO (SL)', this.parametrosPortada.nivel_servicio]);
            sheet.addRow(['UMBRAL DE TIEMPO (S)', this.parametrosPortada.umbral]);
            sheet.addRow(['OBJETIVO DE REQUERIMIENTO (RQ)', `${this.parametrosPortada.objetivoRQ}%`]);
            sheet.addRow(['OBJETIVO DE EFICIENCIA', `${this.parametrosPortada.objetivoEficiencia}%`]);

            sheet.addRow([]); // Espacio

            // --- 5. VENTANAS DE OPERACIÓN ---
            sheet.addRow(['VENTANAS DE OPERACIÓN SEMANAL']).font = { bold: true, color: { argb: 'FF757575' } };
            this.infoServicio.ventanas.forEach(v => {
                sheet.addRow([v.dia_semana.toUpperCase(), `${v.hora_apertura} - ${v.hora_cierre}`]);
            });

            sheet.addRow([]); // Espacio

            // --- 6. NUEVO: REGLAS DE AUXILIARES Y DESCANSO ---
            sheet.addRow(['REGLAS DE AUXILIARES Y DESCANSO']).font = { bold: true, color: { argb: 'FF757575' } };

            // Fila de Descanso Semanal (Estilo Highlight)
            const descansoRow = sheet.addRow(['DESCANSO SEMANAL:', `${this.infoServicio.max_descanso} día(s)`]);
            descansoRow.getCell(1).font = { bold: true };
            descansoRow.getCell(2).font = { bold: true, color: { argb: 'FF3F51B5' } }; // Indigo

            // Tabla de Auxiliares
            const auxHeader = sheet.addRow(['TIPO AUXILIAR', 'DURACIÓN', 'JORNADA MÍN/MÁX']);
            auxHeader.eachCell(cell => {
                cell.font = { bold: true, size: 9 };
                cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFF5F5F5' } }; // Grey lighten-4
                cell.border = { bottom: { style: 'thin' } };
            });

            this.infoServicio.auxiliares.forEach(aux => {
                sheet.addRow([
                    aux.tipo,
                    aux.duracion,
                    `${aux.jornada_min}h - ${aux.jornada_max}h`
                ]);
            });

            sheet.addRow([]); // Espacio
            sheet.addRow([]); // Espacio

            // --- 7. NUEVO: PIE DE PÁGINA (Vigencia y Solicitante) ---
            const footerStartRow = sheet.lastRow.number + 1;
            sheet.mergeCells(`A${footerStartRow}:E${footerStartRow}`);

            const footerCell = sheet.getCell(`A${footerStartRow}`);
            footerCell.value = `VIGENCIA: ${this.portadaProcesada.vigenciaRango}  |  ELABORADO POR: ${this.portadaProcesada.solicitaNombre}`;
            footerCell.font = { size: 9, italic: true, color: { argb: 'FF616161' } };
            footerCell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFF5F5F5' } };
            footerCell.alignment = { horizontal: 'center' };
            footerCell.border = { outline: { style: 'thin', color: { argb: 'FFEEEEEE' } } };


            const tiposReceso = ['receso60', 'receso30', 'receso15'];

            for (const tab of this.tabsPersonalizados) {
                const entregable = this.TablasGraficas.find(e => e.nombre_datos === tab.tipo);
                if (!entregable) continue;

                if (entregable.nombre_datos === 'TablaResumenSemanal') {
                    const sheet = workbook.addWorksheet(tab.label || 'Resumen');
                    const headers = ['Agente'];
                    entregable.headers.forEach(dia => {
                        headers.push(`${dia} Horario`);
                        tiposReceso.forEach(tipo => {
                            headers.push(`${dia} ${tipo.replace('receso', 'R.')}`);
                        });
                    });
                    const headerRow = sheet.addRow(headers);
                    headerRow.eachCell(cell => {
                        cell.font = { bold: true, color: { argb: 'FF0C0C0C' } }; // color texto
                        cell.alignment = { horizontal: 'center', vertical: 'middle' };
                        cell.fill = {
                            type: 'pattern',
                            pattern: 'solid',
                            fgColor: { argb: 'FFF9F9F9' } // fondo encabezado
                        };
                        cell.border = {
                            top: { style: 'thin', color: { argb: 'FFCCCCCC' } },
                            left: { style: 'thin', color: { argb: 'FFCCCCCC' } },
                            bottom: { style: 'thin', color: { argb: 'FFCCCCCC' } },
                            right: { style: 'thin', color: { argb: 'FFCCCCCC' } }
                        };
                    });

                    // Filas de datos
                    entregable.items.forEach((item, index) => {
                        const fila = [item.agente];
                        entregable.headers.forEach(dia => {

                            const diaMinusculas = dia.toLowerCase();

                            const limpiarFormato = (valor) => {
                                if (!valor || valor === '—') return '—';
                                return valor.replace(/[—–]/g, '-');
                            };

                            // Columna Horario
                            const horarioRaw = item[`${diaMinusculas}_horario`] ?? '';
                            fila.push(limpiarFormato(horarioRaw));

                            // Columnas de Receso (15, 30, 60)
                            tiposReceso.forEach(tipo => {
                                const recesoRaw = item[`${diaMinusculas}_${tipo}`] ?? '';
                                fila.push(limpiarFormato(recesoRaw));
                            });
                        });

                        const row = sheet.addRow(fila);
                        row.eachCell((cell, colNumber) => {
                            // Estilo base
                            cell.font = { color: { argb: 'FF0C0C0C' } };
                            cell.alignment = { horizontal: 'center', vertical: 'middle' };
                            cell.border = {
                                top: { style: 'thin', color: { argb: 'FFCCCCCC' } },
                                left: { style: 'thin', color: { argb: 'FFCCCCCC' } },
                                bottom: { style: 'thin', color: { argb: 'FFCCCCCC' } },
                                right: { style: 'thin', color: { argb: 'FFCCCCCC' } }
                            };

                            if (colNumber > 1) {
                                const indiceDia = Math.floor((colNumber - 2) / 4);

                                // Intercalamos color: los días pares (0, 2, 4...) fondo gris, impares blanco.
                                if (indiceDia % 2 === 0) {
                                    cell.fill = {
                                        type: 'pattern',
                                        pattern: 'solid',
                                        fgColor: { argb: 'FFE9ECEF' } // Gris muy claro para el bloque del día
                                    };
                                } else {
                                    cell.fill = {
                                        type: 'pattern',
                                        pattern: 'solid',
                                        fgColor: { argb: 'FFFFFFFF' } // Blanco
                                    };
                                }
                            }

                            if (typeof cell.value === 'string' && cell.value.trim().toUpperCase() === 'DS') {
                                cell.font = { color: { argb: 'FFC00000' }, bold: true, italic: true };
                                cell.fill = {
                                    type: 'pattern',
                                    pattern: 'solid',
                                    fgColor: { argb: 'FFFFEAEA' } // Fondo rosado
                                };
                            }
                        });
                    });

                    // Ajustar ancho de columnas
                    sheet.columns.forEach(col => {
                        col.width = 15;
                    });

                }

                else if (entregable.nombre_datos === 'ResumenFTE') {
                    const sheet = workbook.addWorksheet(tab.label || 'Resumen FTE');

                    // 1. Preparar datos
                    const detalle = entregable.items.detalle || [];
                    const headersJornada = detalle.map(item => item.jornada);
                    const valoresAgentes = detalle.map(item => item.agentes);
                    const resumenTotal = entregable.items.resumenTotal || { agentes: 0, fte: 0 };
                    const totalColumnas = headersJornada.length + 2; // Jornadas + Total Op + Total FTE

                    // 2. Fila 1 de Encabezado: "Jornadas laborales", "Total Operadores", "Total FTEs"
                    const cabecera1 = [
                        'Jornadas laborales', // Este será el título principal
                        ...Array(headersJornada.length - 1).fill(''), // Relleno para fusionar
                        'Total Operadores',
                        'Total FTEs'
                    ];
                    let row1 = sheet.addRow(cabecera1);

                    // Fusionar celdas de "Jornadas laborales" (si hay jornadas)
                    if (headersJornada.length > 0) {
                        sheet.mergeCells(1, 1, 1, headersJornada.length);
                    }

                    // 3. Fila 2 de Encabezado: Nombres de las Jornadas
                    const cabecera2 = [
                        ...headersJornada,
                        '', // Celda vacía bajo 'Total Operadores'
                        '' // Celda vacía bajo 'Total FTEs'
                    ];
                    let row2 = sheet.addRow(cabecera2);

                    // Estilo para ambas filas de cabecera (incluyendo el color de fondo)
                    [row1, row2].forEach(row => {
                        row.eachCell(cell => {
                            cell.font = { bold: true, color: { argb: 'FF0C0C0C' } };
                            cell.alignment = { horizontal: 'center', vertical: 'middle' };
                            cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFE0E0E0' } }; // Fondo gris claro (como tu CSS)
                            cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
                        });
                    });

                    // 4. Fila Única de Datos: Agentes por Jornada y Totales (Operadores y FTE)
                    const filaDatos = [
                        ...valoresAgentes,
                        resumenTotal.agentes,
                        resumenTotal.fte
                    ];
                    let row3 = sheet.addRow(filaDatos); // Esta es la única fila de datos

                    // 5. Estilo para la fila de Datos
                    row3.eachCell((cell, colNumber) => {
                        cell.alignment = { horizontal: 'center', vertical: 'middle' };
                        cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };

                        // Estilo para las columnas de Totales (las dos últimas)
                        if (colNumber > headersJornada.length) {
                            cell.font = { bold: true };
                            cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFBBDEFB' } }; // Fondo azul claro para resaltar
                        }
                    });

                    // Ajustar ancho de columnas
                    sheet.columns.forEach(col => {
                        col.width = 15;
                    });
                }

                else if (entregable.tipo === 'Tabla') {
                    const sheet = workbook.addWorksheet(tab.label || entregable.nombre_datos);

                    // 1. Definir parámetros para cálculos (se hace una vez por pestaña)
                    const entregableParams = this.TablasGraficas.find(e => e.nombre_datos === 'ParametrosCalculo');
                    const objRQ = entregableParams ? parseFloat(entregableParams.items.objetivoRQ) / 100 : 0;
                    const objEficiencia = entregableParams ? parseFloat(entregableParams.items.objetivoRQ) / 100 : 0;

                    // Encabezado con estilo teal
                    const headers = entregable.headers.map(h => h.text);
                    const headerRow = sheet.addRow(headers);

                    headerRow.eachCell(cell => {
                        cell.font = {
                            bold: true,
                            color: { argb: 'FFFFFFFF' } // blanco
                        };
                        cell.fill = {
                            type: 'pattern',
                            pattern: 'solid',
                            fgColor: { argb: 'FF008080' } // teal
                        };
                        cell.alignment = { horizontal: 'center', vertical: 'middle' };
                        cell.border = {
                            top: { style: 'thin', color: { argb: 'FFCCCCCC' } },
                            left: { style: 'thin', color: { argb: 'FFCCCCCC' } },
                            bottom: { style: 'thin', color: { argb: 'FFCCCCCC' } },
                            right: { style: 'thin', color: { argb: 'FFCCCCCC' } }
                        };
                    });

                    // Filas de datos con alternancia de color
                    /*entregable.items.forEach((item, index) => {
                        const fila = entregable.headers.map(h => item[h.value] ?? '');
                        const row = sheet.addRow(fila);

                        const esPonderado = ['Ponderado', 'Mensual'].includes(item.dia);

                        row.eachCell(cell => {
                            cell.font = {
                                bold: esPonderado, // aplicar negrita si es ponderado
                                color: { argb: 'FF0C0C0C' }
                            };
                            cell.alignment = { horizontal: 'center', vertical: 'middle' };
                            cell.fill = {
                                type: 'pattern',
                                pattern: 'solid',
                                fgColor: { argb: index % 2 === 0 ? 'FFF6F6F6' : 'FFFFFFFF' } // alternar fondo
                            };
                            cell.border = {
                                top: { style: 'thin', color: { argb: 'FFCCCCCC' } },
                                left: { style: 'thin', color: { argb: 'FFCCCCCC' } },
                                bottom: { style: 'thin', color: { argb: 'FFCCCCCC' } },
                                right: { style: 'thin', color: { argb: 'FFCCCCCC' } }
                            };
                        });
                    });*/

                    entregable.items.forEach((item, index) => {
                        const fila = entregable.headers.map(h => item[h.value] ?? '');
                        const row = sheet.addRow(fila);
                        const esPonderado = ['Ponderado', 'Mensual'].includes(item.dia);

                        row.eachCell((cell, colNumber) => {
                            const header = entregable.headers[colNumber - 1];
                            const valorRaw = item[header.value];
                            const valorNum = parseFloat(valorRaw);
                            let estiloFinal = null;

                            // --- A. LÓGICA DE COLORES (Semaforización/Mapa Calor) ---

                            // Si es Eficiencia
                            if (header.value === 'eficienciaSinReductores' || header.value === 'eficienciaConReductores') {
                                if (!isNaN(valorNum) && objEficiencia > 0) {
                                    const factorV = valorNum / 100;
                                    if (factorV >= (1 * objEficiencia)) estiloFinal = COLORES_EXCEL.VERDE;
                                    else if (factorV >= (0.95 * objEficiencia)) estiloFinal = COLORES_EXCEL.AMARILLO;
                                    else if (factorV >= (0.9 * objEficiencia)) estiloFinal = COLORES_EXCEL.ROJO;
                                    else estiloFinal = COLORES_EXCEL.GRIS;
                                }
                            }
                            // Si es la Tabla de Diferencias (Mapa de Calor)
                            else if (entregable.nombre_datos === 'TablaProgramados_Requeridos' && header.value !== 'intervalo') {
                                const tablaAsig = this.TablasGraficas.find(e => e.nombre_datos === 'TablaProgramados');
                                const tablaProg = this.TablasGraficas.find(e => e.nombre_datos === 'TablaRequeridos+Reductores');

                                if (tablaAsig && tablaProg) {
                                    const filaAsig = tablaAsig.items.find(i => i.intervalo === item.intervalo);
                                    const filaProg = tablaProg.items.find(i => i.intervalo === item.intervalo);
                                    const asig = filaAsig ? parseFloat(filaAsig[header.value]) || 0 : 0;
                                    const prog = filaProg ? parseFloat(filaProg[header.value]) || 0 : 0;

                                    if (prog === 0) estiloFinal = COLORES_EXCEL.GRIS;
                                    else {
                                        const factorCumplimiento = asig / prog;
                                        if (factorCumplimiento >= 1.10 * objRQ) estiloFinal = COLORES_EXCEL.ROJO;
                                        else if (factorCumplimiento >= 1.00 * objRQ) estiloFinal = COLORES_EXCEL.VERDE;
                                        else if (factorCumplimiento >= 0.95 * objRQ) estiloFinal = COLORES_EXCEL.AMARILLO;
                                        else estiloFinal = COLORES_EXCEL.GRIS;
                                    }
                                }
                            }

                            // --- B. APLICACIÓN DE ESTILOS ---

                            // Estilo base (Bordes y Alineación)
                            cell.alignment = { horizontal: 'center', vertical: 'middle' };
                            cell.border = {
                                top: { style: 'thin', color: { argb: 'FFCCCCCC' } },
                                left: { style: 'thin', color: { argb: 'FFCCCCCC' } },
                                bottom: { style: 'thin', color: { argb: 'FFCCCCCC' } },
                                right: { style: 'thin', color: { argb: 'FFCCCCCC' } }
                            };

                            if (estiloFinal) {
                                // Color de semáforo/mapa de calor
                                cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: estiloFinal.bg } };
                                cell.font = { bold: true, color: { argb: estiloFinal.text } };
                            } else {
                                // Estilo normal (el que ya tenías de alternancia gris/blanco)
                                cell.font = { bold: esPonderado, color: { argb: 'FF0C0C0C' } };
                                cell.fill = {
                                    type: 'pattern',
                                    pattern: 'solid',
                                    fgColor: { argb: index % 2 === 0 ? 'FFF6F6F6' : 'FFFFFFFF' }
                                };
                            }
                        });
                    });
                    // Ajustar ancho de columnas
                    sheet.columns.forEach(col => {
                        col.width = 15;
                    });

                }

                else if (entregable.tipo === 'Grafica' && this.graficasOrdenadas?.length) {
                    await this.$nextTick(); // espera a que los componentes estén montados

                    const sheet = workbook.addWorksheet('Gráficas por Día');
                    sheet.properties.showGridLines = false;

                    let colOffset = 0; // 0 para izquierda, 8 para derecha
                    let rowOffset = 0; // fila base para cada par

                    for (const grafica of this.graficasOrdenadas) {
                        const refName = `grafica-${grafica.dia}`;
                        const graficaComp = this.$refs[refName];
                        const comp = Array.isArray(graficaComp) ? graficaComp[0] : graficaComp;

                        if (comp && typeof comp.obtenerImagenGrafica === 'function') {
                            let imagenBase64 = comp.obtenerImagenGrafica();

                            if (typeof imagenBase64 === 'string' && imagenBase64.startsWith('data:image/png;base64,')) {
                                imagenBase64 = imagenBase64.replace(/^data:image\/png;base64,/, '');
                                if (imagenBase64.length > 100) {
                                    try {
                                        const imageId = workbook.addImage({
                                            base64: imagenBase64,
                                            extension: 'png',
                                        });

                                        // Insertar título encima de la imagen
                                        const tituloCol = colOffset === 0 ? 'A' : 'K'; // A para izquierda, I para derecha
                                        sheet.getCell(`${tituloCol}${rowOffset + 1}`).value = `📅 ${grafica.dia}`;
                                        sheet.getRow(rowOffset + 1).font = { bold: true };

                                        // Insertar imagen
                                        sheet.addImage(imageId, {
                                            tl: { col: colOffset, row: rowOffset + 2 },
                                            ext: { width: 600, height: 400 },
                                        });

                                        // Alternar columna: izquierda → derecha → nueva fila
                                        if (colOffset === 0) {
                                            colOffset = 10;
                                        } else {
                                            colOffset = 0;
                                            rowOffset += 22;
                                        }
                                    } catch (error) {
                                        console.error(`Error al insertar imagen en ${grafica.dia}:`, error);
                                    }
                                }
                            }
                        } else {
                            console.warn(`No se encontró el componente gráfico para ${grafica.dia}`);
                        }
                    }
                }
            }

            try {
                const buffer = await workbook.xlsx.writeBuffer();
                const blob = new Blob([buffer], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                });
                const link = document.createElement('a');
                link.href = URL.createObjectURL(blob);
                link.download = `Detalle_${this.programacionSeleccionada?.nombre_programacion || 'programacion'}.xlsx`;
                link.click();
            } catch (error) {
                console.error('Error al generar el archivo Excel:', error);
            }
        },
    }
}
export default Exports